import { Fragment } from 'react';

import OrgUnitAdminContactsGrid from './OrgUnitAdminContactsGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

const OrgUnitAdminContactsWrite = ({ onAddContact, onEditContact, onDeleteContactClicked, omeMeetOrgUnitContactState }) => {

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H5>Entry Contacts</Headings.H5>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin">
          <ActionIntraPageButton onClick={onAddContact}>Add Entry Contact</ActionIntraPageButton>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className='col-xs-12'>
          <OrgUnitAdminContactsGrid
            gridData={omeMeetOrgUnitContactState.arrayData}
            isLoading={omeMeetOrgUnitContactState.isArrayLoading}
            onEditContact={onEditContact}
            onDeleteContactClicked={onDeleteContactClicked}
          />
        </div>
      </div>
    </Fragment>
  )
}

export default OrgUnitAdminContactsWrite;